import { useState, useEffect } from 'react';
import { useRedirect } from 'react-admin';
import useApi from './useApi';

const usePDFCreationCount = () => {
    const redirect = useRedirect();
    const [count, setCount] = useState(null);
    const api = useApi(process.env.REACT_APP_API_URL);
    
    useEffect(() => {
        api.get('/pdfcount').then((response) => {
            setCount(response.data[0].value);
        }).catch((error) => {
            if (error.response.status === 500) {
                redirect('/login');
            }
        });
    });

    return { count };
};

export default usePDFCreationCount;